import { ButtonPropsVariantOverrides } from '@mui/material/Button';
import { createTheme } from '@mui/material/styles';

import PPNeueMontrealThin from "./assets/fonts/PPNeueMontreal-Thin.otf";
import PPNeueMontrealBook from "./assets/fonts/PPNeueMontreal-Book.otf";
import PPNeueMontrealMedium from "./assets/fonts/PPNeueMontreal-Medium.otf";
import PPNeueMontrealBold from "./assets/fonts/PPNeueMontreal-Bold.otf";
import PPNeueMontrealItalic from "./assets/fonts/PPNeueMontreal-Italic.otf";
import fontSizes from "./style/fontSizes";
import colors from "./style/colors";

export {fontSizes as fontSizes};
export {colors as colors};

export type ReportColorStyleName = "red" | "pink" | "orange" | "green" | "blue" | "yellow" | "purple" | "black";

export interface ReportColorStyle {
    main: string;
    light: string;
    dark: string;
    text: string;
}

declare module "@mui/material/styles" {
    interface TypographyVariants {
      thin: React.CSSProperties;
      extralight: React.CSSProperties;
      light: React.CSSProperties;
      normal: React.CSSProperties;
      medium: React.CSSProperties;
      semibold: React.CSSProperties;
      bold: React.CSSProperties;
      extrabold: React.CSSProperties;
      black: React.CSSProperties;
    }
  
    interface TypographyVariantsOptions {
      thin?: React.CSSProperties;
      extralight?: React.CSSProperties;
      light?: React.CSSProperties;
      normal?: React.CSSProperties;
      medium?: React.CSSProperties;
      semibold?: React.CSSProperties;
      bold?: React.CSSProperties;
      extrabold?: React.CSSProperties;
      black?: React.CSSProperties;
    }
  }
  
  declare module "@mui/material/Typography" {
    interface TypographyPropsVariantOverrides {
      thin: true;
      extralight: true;
      light: true;
      normal: true;
      medium: true;
      semibold: true;
      bold: true;
      extrabold: true;
      black: true;
    }
  }


declare module '@mui/material/styles' {
    interface Palette {
        purple: Palette['primary'];
        blackButton: Palette['primary'];
        greyButton: Palette['primary'];
        whiteButton: Palette['primary'];
        redLink: PaletteOptions['primary'];
        blackLink: PaletteOptions['primary'];
        uploadButton: PaletteOptions['primary'];
        reportColorStyles: Partial<Record<ReportColorStyleName, ReportColorStyle>>;
    }
    interface PaletteOptions {
        purple: PaletteOptions['primary'];
        blackButton?: PaletteOptions['primary'];
        greyButton?: PaletteOptions['primary'];
        whiteButton?: PaletteOptions['primary'];
        redLink?: PaletteOptions['primary'];
        blackLink?: PaletteOptions['primary'];
        uploadButton?: PaletteOptions['primary'];
        reportColorStyles: Partial<Record<ReportColorStyleName, ReportColorStyle>>;
    }
}

declare module '@mui/material/Button' {
    interface ButtonPropsColorOverrides {
        blackButton: true;
        greyButton: true;
        whiteButton: true;
        redLink: true;
        blackLink: true;
        uploadButton: true;
    }
}


declare module "@mui/material/styles" {
    interface TypographyVariants {
        title: React.CSSProperties;
        "error": React.CSSProperties;
        "report.date": React.CSSProperties;
        "report.headline": React.CSSProperties;
        "report.title": React.CSSProperties;
        "report.info.label": React.CSSProperties;
        "report.info.value": React.CSSProperties;
        "report.chart.label": React.CSSProperties;
        "report.card.title": React.CSSProperties;
        "report.card.range.large": React.CSSProperties;
        "report.card.range.normal": React.CSSProperties;
        "report.card.info.title": React.CSSProperties;
        "report.card.info.large": React.CSSProperties;
        "report.card.info.label": React.CSSProperties;
        "report.card.info.value": React.CSSProperties;
        "report.steps.title": React.CSSProperties;
        "report.steps.large": React.CSSProperties;
        "report.footer": React.CSSProperties;
        "calculator.subheading": React.CSSProperties;
        "calculator.label": React.CSSProperties;
        "calculator.input": React.CSSProperties;
        "calculator.option": React.CSSProperties;
        "calculator.resultButton": React.CSSProperties;
        "report.table.large": React.CSSProperties;
        "report.table.normal": React.CSSProperties;
        pagination: React.CSSProperties;
        "navbar": React.CSSProperties;
    }

    interface TypographyVariantsOptions {
        title: React.CSSProperties;
        "error"?: React.CSSProperties;

        "report.date"?: React.CSSProperties;
        "report.headline"?: React.CSSProperties;
        "report.title"?: React.CSSProperties;
        "report.info.label"?: React.CSSProperties;
        "report.info.value"?: React.CSSProperties;
        "report.chart.label"?: React.CSSProperties;
        "report.card.title"?: React.CSSProperties;
        "report.card.range.large"?: React.CSSProperties;
        "report.card.range.normal"?: React.CSSProperties;
        "report.card.info.title"?: React.CSSProperties;
        "report.card.info.large"?: React.CSSProperties;
        "report.card.info.label": React.CSSProperties;
        "report.card.info.value": React.CSSProperties;
        "report.card.info.normal"?: React.CSSProperties;
        "report.steps.title"?: React.CSSProperties;
        "report.steps.large"?: React.CSSProperties;
        "report.footer"?: React.CSSProperties;
        "calculator.heading"?: React.CSSProperties;
        "calculator.subheading"?: React.CSSProperties;
        "calculator.label"?: React.CSSProperties;
        "calculator.input"?: React.CSSProperties;
        "calculator.option"?: React.CSSProperties;
        "calculator.resultButton"?: React.CSSProperties;
        "report.table.large"?: React.CSSProperties;
        "report.table.normal"?: React.CSSProperties;
        pagination?: React.CSSProperties;
        "navbar"?: React.CSSProperties;
    }
}

declare module "@mui/material/Typography" {
    interface TypographyPropsVariantOverrides {
        title: true;
        "error": true;
        "report.date": true;
        "report.headline": true;
        "report.title": true;
        "report.info.label": true;
        "report.info.value": true;
        "report.chart.label": true;
        "report.card.title": true;
        "report.card.range.large": true;
        "report.card.range.normal": true;
        "report.card.info.title": true;
        "report.card.info.large": true;
        "report.card.info.normal": true;
        "report.card.info.label": true;
        "report.card.info.value": true;
        "report.table.large": true;
        "report.table.normal": true;
        "report.steps.title": true;
        "report.steps.large": true;
        "report.footer": true;
        "calculator.heading": true;
        "calculator.subheading": true;
        "calculator.label": true;
        "calculator.input": true;
        "calculator.option": true;
        "calculator.resultButton": true;
        pagination: true;
        "navbar": true;
    }
}


const theme = createTheme({
    palette: {
        purple: {
            main: "#EDE9FE",
        },
        primary: {
            main: '#1976d2', 
        },
        secondary: {
            main: '#F5F5F4', 
        },
        background: {
            default: '#FAFAF9', 
        },
        blackButton: {
            main: colors.stone[950],
            contrastText: colors.stone[50],
        },
        whiteButton: {
            main: '#FFFFFF',
            contrastText: '#000000',
        },
        greyButton: {
            main: '#B0B0B0',
            contrastText: '#000000',
        },
        redLink: {
            main: '#DC2626',
        },
        blackLink: {
            main: '#0C0A09'
        },
        uploadButton: {
            main: '#FFFFFF',
        },
        reportColorStyles: {
            "red": {
                "main": colors.red[500],
                "light": colors.red[50],
                "dark": colors.red[500],
                "text": colors.stone[950]
            },
            "pink": {
                "main": colors.pink[500],
                "light": colors.pink[200],
                "dark": colors.pink[500],
                "text": colors.stone[950]
            },
            "orange": {
                "main": colors.orange[500],
                "light": colors.orange[200],
                "dark": colors.orange[500],
                "text": colors.stone[950]
            },
            "green": {
                "main": colors.green[500],
                "light": colors.green[200],
                "dark": colors.green[500],
                "text": colors.stone[950]
            },
            "blue": {
                "main": colors.blue[500],
                "light": colors.blue[200],
                "dark": colors.blue[500],
                "text": colors.stone[950]
            },
            "yellow": {
                "main": colors.yellow[500],
                "light": colors.yellow[200],
                "dark": colors.yellow[500],
                "text": colors.stone[950]
            },
            "purple": {
                "main": colors.violet[500],
                "light": colors.violet[200],
                "dark": colors.violet[500],
                "text": colors.stone[950]
            },
            "black": {
                "main": colors.zinc[500],
                "light": colors.zinc[200],
                "dark": colors.zinc[500],
                "text": colors.stone[50]
            }
        }


    },
    typography: {
        fontFamily: "PPNeueMontreal, Inter, Arial, sans-serif",
        fontSize: 16,
        thin: {
          fontWeight: 100,
        },
        extralight: {
          fontWeight: 200,
        },
        light: {
          fontWeight: 300,
        },
        normal: {
          fontWeight: 400,
        },
        medium: {
          fontWeight: 500,
        },
        semibold: {
          fontWeight: 600,
        },
        bold: {
          fontWeight: 700,
        },
        extrabold: {
          fontWeight: 800,
        },
        black: {
          fontWeight: 900,
        },

        h1: {
            fontSize: 'var(--fontsize2xl)',
            fontWeight: 800,
            lineHeight: 'var(--fontline-height8)',
            letterSpacing: 'var(--fontletter-spacingnormal)',
            textAlign: 'left',
            color: "#0C0A09"
        },
        h2: {
            fontSize: '1.9rem',
            fontWeight: 800,
            lineHeight: 'var(--fontline-height8)',
            letterSpacing: 'var(--fontletter-spacingnormal)',
            textAlign: 'left',
            color: "#0C0A09"
        },
        error: {
            color: "red"
        },
        "report.date": {
            color: "#64748B",
            textAlign: 'right',
            fontSize: "0.8rem",
        },
        "report.headline": {
            fontSize: '2rem',
            fontWeight: 800,
            lineHeight: 1.5,
            paddingBottom: 12,
            paddingTop: 12,
            color: "#0F172A",
        },
        "report.title": {
            fontSize: 20,
            fontWeight: 600,
            color: "#0F172A",
        },
        "report.info.label": {
            fontSize: '1rem',
            color: "#475569",
            lineHeight: 1.6,
        },
        "report.info.value": {
            fontSize: '1rem',
            color: "#0C0A09",
            lineHeight: 1.6,
        },
        "report.chart.label": {
            fontSize: '1.1rem',
            color: "#6B7280",
            lineHeight: 1.4,
        },
        "report.card.title": {
            fontSize: '1.25rem',
            fontWeight: 600,
            color: "#0F172A",
            textAlign: 'center',
        },
        "report.card.range.large": {
            fontSize: '2rem',
            fontWeight: 800,
            color: "#FFFFFF",
        },
        "report.card.range.normal": {
            fontSize: '1rem',
            color: "#FFFFFF",
        },
        "report.card.info.title": {
            fontSize: '1rem',
            fontWeight: 600,
            color: "#475569",
        },
        "report.card.info.large": {
            fontSize: '1.5rem',
            fontWeight: 700,
            color: "#0F172A",
        },
        "report.card.info.normal": {
            fontSize: '1rem',
            color: "#475569",
        },
        "report.table.normal": {
            fontSize: '1rem',
            color: "#475569",
        },
        "report.table.large": {
            fontSize: '1.2rem',
            color: "#475569",
        },
        "report.steps.title": {
            fontSize: '1.2rem',
            color: "#0F172A",
        },
        "report.steps.large": {
            fontSize: '1.4rem',
            color: "#0F172A",
        },
        "report.footer": {
            fontSize: "15px",
            color: "#64748B"
        },
        "report.card.info.label": {
            fontSize: '1rem',
            color: "#475569",
        },
        "report.card.info.value": {
            fontSize: '1rem',
            color: "#0F172A",
        },
        "calculator.heading": {
            fontSize: '2.5rem',
            fontWeight: 700,
            color: "#1F2937",
        },
        "calculator.subheading": {
            fontSize: '1.125rem',
            fontWeight: 500,
            color: "#4B5563",
            lineHeight: 1.75,
        },
        "calculator.label": {
            fontSize: '1rem',
            color: "#374151",
        },
        "calculator.input": {
            fontSize: '1rem',
            color: "#111827",
        },
        "calculator.option": {
            fontSize: '1rem',
            color: "#6B7280",
        },
        "calculator.resultButton": {
            fontSize: '1.125rem',
            fontWeight: 600,
            color: "#FFFFFF",
            backgroundColor: "#111827",
        },
        subtitle1: {
            fontFamily: 'Inter, Arial, sans-serif',
            fontSize: 'px',
            fontWeight: 400,
            lineHeight: 'var(--fontline-height5)',
            letterSpacing: 'var(--fontletter-spacingnormal)',
            textAlign: 'center',
            color: "#78716C"

        },
        title: {
            fontFamily: 'var(--fontfamilysans)',
            fontSize: 'var(--fontsizebase)',
            fontWeight: 600,
            lineHeight: 'var(--fontline-height6)',
            letterSpacing: 'var(--fontletter-spacingnormal)',
            textAlign: 'left',
        },
        pagination: {
            fontSize: '14px',
            color: '0C0A09',
        },
        "navbar": {
            fontSize: '14px',
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
              @font-face {
                font-family: 'PPNeueMontreal';
                src: url(${PPNeueMontrealThin}) format('opentype');
                font-weight: 100;
                font-style: normal;
              }
              @font-face {
                font-family: 'PPNeueMontreal';
                src: url(${PPNeueMontrealBook}) format('opentype');
                font-weight: 400;
                font-style: normal;
              }
              @font-face {
                font-family: 'PPNeueMontreal';
                src: url(${PPNeueMontrealMedium}) format('opentype');
                font-weight: 500;
                font-style: normal;
              }
              @font-face {
                font-family: 'PPNeueMontreal';
                src: url(${PPNeueMontrealBold}) format('opentype');
                font-weight: 700;
                font-style: normal;
              }
              @font-face {
                font-family: 'PPNeueMontreal';
                src: url(${PPNeueMontrealItalic}) format('opentype');
                font-weight: 400;
                font-style: italic;
              }
            `,
          },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: '#000000',
                    textDecoration: "underline",
                },
            },
            defaultProps: {
                color: 'blackLink',
                underline: 'none',
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    margin: '0',
                    padding: '0px',
                    backgroundColor: 'transparent',
                    '& .MuiInputBase-root': {
                        'backgroundColor': 'white',
                    }
                },
            },  
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    margin: '0',
                    padding: '0px',
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#E7E5E4',  
                        },
                        '&:hover fieldset': {
                            // borderColor: '#6b4f3d',  
                        },
                        '&.Mui-focused fieldset': {
                            // borderColor: '#5f4327',  
                        },
                    },
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    padding: '8px', 
                },
                input: {
                    padding: '6px 8px', 
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    padding: '0px 0px', 
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    // fontWeight: "bold!",
                    // color: colors.stone[950],
                    // fontSize: fontSizes.sm,
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    "&.Mui-error": {
                        color: colors.red[600],
                    }
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: 'white',
                    color: '#0C0A09',
                },
            },
        },
        MuiContainer: {
            styleOverrides: {
                maxWidthSm: {
                    maxWidth: '600px',
                },
                maxWidthMd: {
                    maxWidth: '900px',
                },
              
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },

            },
            defaultProps: {
                size: "small"
            },
            variants: [
                {
                    props: { variant: "text" },
                    style: {
                        color: '#000000',
                        // textDecoration: "underline",
                    },
                },
                {
                    props: { color: 'uploadButton', size: "small" },
                    style: {
                        backgroundColor: '#EDE9FE',
                        color: '#000000',
                        '&:hover': {
                            backgroundColor: '#EDE9FE',
                        },
                        padding: "12px 32px",
                        fontSize: 14,
                        whiteSpace: "nowrap",
                        borderRadius: 12,
                        border: "1px dashed #E7E5E4",
                        height: "auto"
                    },
                },
                {
                    props: { color: 'whiteButton', size: "small" },
                    style: {
                        backgroundColor: '#FFFFFF',
                        border: "1px solid #E7E5E4",
                        color: '#000000',
                        '&:hover': {
                            backgroundColor: '#F0F0F0',
                        },
                        height: 44,
                        padding: "0 8px",
                        fontSize: 14,
                        whiteSpace: "nowrap",
                        borderRadius: 12
                    },
                },
                {
                    props: { color: 'greyButton', size: "small" },
                    style: {
                        backgroundColor: '#F5F5F4',
                        border: "1px solid #E7E5E4",
                        color: '#000000',
                        '&:hover': {
                            backgroundColor: '#A0A0A0',
                        },
                        height: 44,
                        paddingX: 16,
                        fontSize: 14,
                        whiteSpace: "nowrap",
                        borderRadius: 12
                    },
                },
                {
                    props: { color: 'blackButton', size: "small" },
                    style: {
                        backgroundColor: '#000000',
                        border: "1px solid #E7E5E4",
                        color: '#FFFFFF',
                        '&:hover': {
                            backgroundColor: '#333333',
                        },
                        '&:disabled': {
                            color: '#FFFFFF',
                        },
                        height: 44,
                        padding: "0 8px",
                        fontSize: 14,
                        whiteSpace: "nowrap",
                        borderRadius: 12
                    },
                },
            ],
        },
        
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    border: '1px solid #E7E5E4',
                    borderRadius: '8px',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    backgroundColor: colors.stone[100],
                    color: colors.stone[900],
                    fontWeight: "bold"
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: '#000000',
                    '&.Mui-checked': {
                        color: '#000000',
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    fontSize: '1.2rem',
                    borderColor: '#78716C',
                },
                head: {
                    color: '#78716C',
                    borderColor: '#78716C',
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: 'transparent',
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    variants: [
                        {
                            props: { variant: "overview" },
                            style: {
                                "& td": {
                                    backgroundColor: "red"
                                },
                                border: '1px solid #E7E5E4',
                                borderRadius: '8px',
                                backgroundColor: "white"
                            },
                        }
                    ]
                }
            }
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    "&.loading": {
                        opacity: 0.5,
                    },
                    boxShadow: 'none',
                    borderRadius: 8,
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    boxShadow: "#f3f3f3 0px 0px 2px 0px",
                    backgroundColor: '#ffffff',
                    color: "rgba(77, 86, 92, 0.7)",
                    border: `3px solid #E7E5E4`,
                    fontSize: '0.875rem',
                },
            },
        },

    }
});

export const sidebarWidth = 260;

export default theme;